module.exports = __webpack_public_path__ + "img/10_pc.6bd86ffd.gif";